// Get Discover
export const GET_DISCOVER_REQUEST = 'GET_DISCOVER_REQUEST';
export const GET_DISCOVER_DONE = 'GET_DISCOVER_DONE';
export const GET_DISCOVER_FAILED = 'GET_DISCOVER_FAILED';
export const GET_DISCOVER_RESET = 'GET_DISCOVER_RESET';

// Operations
export const UPDATE_USER_DISCOVER_USERS = 'UPDATE_USER_DISCOVER_USERS';
export const UPDATE_MULTI_USER_DISCOVER_USERS = 'UPDATE_MULTI_USER_DISCOVER_USERS';
export const SET_DISCOVER_FILTER = 'SET_DISCOVER_FILTER';
export const SET_DISCOVER_ALL_FILTERS = 'SET_DISCOVER_ALL_FILTERS';
export const CLEAR_DISCOVER_FILTERS = 'CLEAR_DISCOVER_FILTERS';
export const SET_DISCOVER_COLUMNS = 'SET_DISCOVER_COLUMNS';
export const DISCOVER_SET_PAGE = 'DISCOVER_SET_PAGE';

// Get Discover Tags
export const GET_DISCOVER_TAGS_REQUEST = 'GET_DISCOVER_TAGS_REQUEST';
export const GET_DISCOVER_TAGS_DONE = 'GET_DISCOVER_TAGS_DONE';
export const GET_DISCOVER_TAGS_FAILED = 'GET_DISCOVER_TAGS_FAILED';

// Get Discover Users Tags Bulk
export const ADD_DISCOVER_USERS_TAGS_BULK_REQUEST = 'ADD_DISCOVER_USERS_TAGS_BULK_REQUEST';
export const ADD_DISCOVER_USERS_TAGS_BULK_DONE = 'ADD_DISCOVER_USERS_TAGS_BULK_DONE';
export const ADD_DISCOVER_USERS_TAGS_BULK_FAILED = 'ADD_DISCOVER_USERS_TAGS_BULK_FAILED';

// Save Columns Width
export const SAVE_DISCOVER_COLUMNS = 'SAVE_DISCOVER_COLUMNS';
